import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper } from '@mui/material';
import ExpiryTrendChart from './ExpiryTrendChart';

const TrendsChart = ({ dates }) => {
  return (
    <Box className="trends-chart-container">
      <div className="flex w-full justify-between">
        {/* Add any filters or controls here */}
      </div>
      <Paper 
        elevation={0} 
        sx={{ 
          width: '100%',
          position: 'relative',
          minHeight: '600px', 
          borderRadius: '8px',
          overflow: 'hidden',
          // padding: '16px'
        }}
        className='p-0 md:p-4 lg:p-4'
      >
        <ExpiryTrendChart />
      </Paper>
    </Box>
  );
};

TrendsChart.propTypes = {
  dates: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default TrendsChart;
